import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <img
        src="/assets/Footer/logo_branco_completo.png"
        alt="Logo Apllos"
        className="footer-logo"
      />
    </footer>
  )
}

export default Footer
